import { Fragment, useEffect, useState } from "react";
import { NewExternalOrder } from "./AddNewExternalDialog";
import ManyToOneSelect from "@/shared/forms/ManyToOneSelect";
import LabelWrapper from "@/components/root/LabelWrapper";
import dayjs from "dayjs";
import ApiService from "@/api/ApiService";

export default function ExternalMaterialSelector({
  plantId,
  customerId,
  article,
  date,
  position,
  onChange,
}: {
  plantId: number | null;
  date: string;
  customerId: number | null;
  article: NewExternalOrder["article"] | null;
  position: NewExternalOrder["position"] | null;
  onChange: (article: NewExternalOrder["article"], position: NewExternalOrder["position"]) => void;
}) {
  const [au, setAu] = useState(
    !!position ? position.supplierOrder : !!article ? { id: 0, number: "Ohne Auftrag", name: "Freie Material-Auswahl" } : null,
  );

  useEffect(
    () => setAu(!!position ? position.supplierOrder : !!article ? { id: 0, number: "Ohne Auftrag", name: "Freie Material-Auswahl" } : null),
    [customerId],
  );

  return !plantId || !customerId ? (
    <LabelWrapper label="Artikel">Bitte wähle zuerst Kunde und Mischanlage</LabelWrapper>
  ) : (
    <Fragment>
      <ManyToOneSelect<NewExternalOrder["position"]["supplierOrder"]>
        entity="supplierOrder"
        showWithoutChoice
        autoSelect={false}
        version="external"
        placeholder="Bitte wählen..."
        size="small"
        value={au}
        displayFunction={(order) =>
          !order
            ? ""
            : order?.number +
              " (" +
              [
                order.name,
                !!order.validFrom
                  ? `Gültig von ${dayjs(order.validFrom).format("DD.MM.YYYY")} bis ${dayjs(order.validUntil).format("DD.MM.YYYY")}`
                  : "",
              ]
                .filter(Boolean)
                .join(" - ") +
              ")"
        }
        showAllOptions={true}
        injectElements={[
          {
            id: 0,
            number: "Ohne Auftrag",
            name: "Freie Material-Auswahl",
            validFrom: "",
            validUntil: "",
          },
        ]}
        onChange={(au: any | null) => setAu(au)}
        wrapper={(c) => <LabelWrapper label="Auftrag">{c}</LabelWrapper>}
        remoteFilter={{ deletedAt: null, externalCustomer: ["externalMaterialCustomer", customerId ?? 0] }}
        filter={(au) => au.validFrom <= date && au.validUntil >= dayjs(date).subtract(1, "month").format("YYYY-MM-DD")}
        remoteFilterReady={!!customerId}
      />
      {!!au ? (
        <ManyToOneSelect<{ article: NewExternalOrder["article"]; position: NewExternalOrder["position"] }>
          entity="custom"
          autoSelect={false}
          queryFn={ApiService.getExternalMaterials(plantId, au?.id ?? 0)}
          queryKeyOverride={["getExternalMaterials", plantId, au?.id ?? 0]}
          remoteFilterReady={!!plantId && (au?.id ?? false) !== false}
          showWithoutChoice
          placeholder="Bitte wählen..."
          size="small"
          value={!!article ? { article, position, id: !!position ? position.id : article.id } : null}
          displayFunction={(pair) =>
            !pair
              ? ""
              : pair.article.name + " (" + [pair.article.number, !!pair.position ? pair.position.deliveryType : ""].filter(Boolean).join(" - ") + ")"
          }
          showAllOptions={au?.id !== 0}
          onChange={(change) => onChange(change?.article, change?.position)}
          wrapper={(c) => <LabelWrapper label="Artikel">{c}</LabelWrapper>}
        />
      ) : (
        <LabelWrapper label="Artikel">Bitte wähle erst einen Auftrag</LabelWrapper>
      )}
    </Fragment>
  );
}
